import { render, staticRenderFns } from "./TermsAndConditionsIndependent.vue?vue&type=template&id=5035dd6c"
import script from "./TermsAndConditionsIndependent.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsIndependent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports